import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getWorkWiseAuthToken } from "../src/Utils/helper";
import { workwiseServices } from "./Api/api";
import { MindMapContext } from "./Context/contex";
import Loader from "./Comp/SkeletonLoader/Loader";
import { getMergedCachedData } from "./Utils/documentCache";

export const AuthenticateDocument = ({ setIsLoading, background = false }) => {

  const navigate = useNavigate();
  const { documentId } = useParams();
  const { setDocumentInfo, setIsReadOnly, setUserInfo, isTemplateDocument, setIsAuthenticated } = MindMapContext();

  // In background mode there is no gating loader to toggle.
  const updateLoading = (value) => {
    if (typeof setIsLoading === "function") setIsLoading(value);
  };

  const handleAuhenticate = async () => {
    try {
      updateLoading(true);
      const searchParams = new URLSearchParams(document.location.search)
      const isReadOnlyQuery = searchParams.get("readOnly")
      if (isReadOnlyQuery == "true") {
        setIsReadOnly(true);
      }
      if (!window.navigator.onLine) {
        window.location.pathname = "/no-internet"
        return;
      }
      else {
        if (!!getWorkWiseAuthToken()) {
          const response = await workwiseServices.getDocumentById(documentId);
          if (response?.status === 200 && response.data?.data?.rightType !== 0 && response.data?.data) {
            updateLoading(false);
            setDocumentInfo(response.data.data);
            setIsAuthenticated(true);
            if (response.data.data.rightType == 1) {
              setIsReadOnly(true);
            }
          }
          if (response.data?.data?.rightType == 0) {
            window.location.pathname = "/unauthorized"
          }
          // history.push("/unauthorized")
        }
        else {
          window.location.pathname = "/unauthorized"
        }
      }
    } catch (error) {
      console.log({ error })
      if (error.response?.data?.responseCode === 1008) {
        if (isTemplateDocument) {
          updateLoading(false);
          setIsAuthenticated(true);
          return;
        }
        else {
          window.location.pathname = "/invalid-document"
        }
      }
      else {
        window.location.pathname = "/unauthorized"
      }
    }
  }

  // Background mode: seed documentInfo from cache up front so the Header has real
  // data instantly, before the auth API returns.
  useEffect(() => {
    if (!background) return;
    const merged = getMergedCachedData(documentId);
    if (merged?.documentInfo) {
      setDocumentInfo(merged.documentInfo);
    }
  }, [background, documentId]);

  useEffect(() => {
    if (isTemplateDocument !== null) {
      handleAuhenticate()
    }
  }, [isTemplateDocument]);

  // In background mode the content is already rendered from cache — no loader.
  if (background) return null;

  return <Loader />

}